import React from "react";
import { Flex } from "@chakra-ui/react";
import SvgContainer from "src/components/SvgContainer";
import { Subtitle } from "src/atoms/typography";

import BatteryIcon from "./BatteryIcon";

export default class BatteryStatus extends React.PureComponent {
  render() {
    const { battery = {}, isDarkMode, ...rest } = this.props;
    // return empty element to prevent layout shift
    if (battery.state == null || battery.state === "UNKNOWN") {
      return <div>{null}</div>;
    }

    const Icon = (props) => (
      <BatteryIcon
        state={battery.state}
        level={battery.level > 20 ? battery.level : 19}
        isDarkMode={isDarkMode}
        {...props}
      />
    );

    return (
      <Flex alignItems="center" {...rest}>
        <SvgContainer icon={Icon} />
        <Subtitle
          ml={["4px", "6px", "8px"]}
          fontSize={["14px", "18px", "22px"]}
          color={isDarkMode ? "white" : "black"}
        >
          {battery.level}%
        </Subtitle>
      </Flex>
    );
  }
}
